import moment from "moment";

import { Plate } from "../helpfull/Plate";
import { Time } from "./Time";
import { Weather } from "./Weather";
import { useDesktopMobile } from "../../hooks/useDesktopMobile";

import datetime from "./DateTime.module.scss";

export const DateTime = () => {
    const shot = moment();

    const dayName = shot.format("dddd");
    const dayNumber = shot.format("D");
    const monthName = shot.format("MMMM");

    return (
        <Plate>
            <article className={datetime.BLOCK}>
                <div className={datetime.left}>
                    <a
                        href={useDesktopMobile(
                            "https://www.timeanddate.com/worldclock/personal.html?cities=224,179,367,369,152&wch=2",
                            "https://play.google.com/store/apps/details?id=com.google.android.deskclock",
                        )}
                        target="_blank"
                        className={datetime.time}
                    >
                        <Time />
                    </a>
                    <a
                        target="_blank"
                        href="https://www.google.com/search?q=weather"
                        className={datetime.weather}
                    >
                        <Weather />
                    </a>
                </div>

                <div className={datetime.divider}></div>

                <p className={datetime.date}>
                    <a
                        href={useDesktopMobile(
                            "https://calendar.google.com/calendar/",
                            "https://play.google.com/store/apps/details?id=com.google.android.calendar",
                        )}
                        target="_blank"
                        className={datetime.dateLink}
                    >
                        <span className={datetime.dayName}>{dayName}</span>
                        <span className={datetime.dayNumber}>{dayNumber}</span>
                        <span className={datetime.monthName}>{monthName}</span>
                    </a>
                </p>
            </article>
        </Plate>
    );
};
